import { FetchData } from '../../cloneme-classes';
import type { UserInfo } from '../../cloneme-classes/FetchDataTypes';
import { UserManager } from '../../cloneme-classes';
import { getCurrentDomainFolder, handleFormSubmit } from '../../utils';

export class RegisterRedirect {
  private userManager?: UserManager;

  public async init(): Promise<void> {
    this.userManager = await UserManager.getInstance();
    this.setUpdateUserProfile();
  }

  public setUpdateUserProfile(): void {
    const updateButton = document.getElementById('user-update-button') as HTMLButtonElement;

    const form: HTMLFormElement = document.getElementById('email-form') as HTMLFormElement;
    handleFormSubmit(form, function():Promise<boolean> {
      const firstName: HTMLInputElement = form.querySelector(
          '#register-first-name'
      ) as HTMLInputElement;
      const lastName: HTMLInputElement = form.querySelector(
          '#register-last-name'
      ) as HTMLInputElement;
      const instagramHandle: HTMLInputElement = form.querySelector(
          '#register-instagram-handle'
      ) as HTMLInputElement;
      const tiktokHandle: HTMLInputElement = form.querySelector(
          '#register-tiktok-handle'
      ) as HTMLInputElement;
      const xHandle: HTMLInputElement = form.querySelector(
          '#register-x-handle'
      ) as HTMLInputElement;
      const onlyFansHandle: HTMLInputElement = form.querySelector(
          '#register-onlyFans-handle'
      ) as HTMLInputElement;
      const mobileNumber: HTMLInputElement = form.querySelector(
          '#register-mobile-number'
      ) as HTMLInputElement;
      const message: HTMLInputElement = form.querySelector(
          '#register-message'
      ) as HTMLInputElement;

      if (firstName) firstName.disabled = true;
      if (lastName) lastName.disabled = true;
      if (instagramHandle) instagramHandle.disabled = true;
      if (tiktokHandle) tiktokHandle.disabled = true;
      if (xHandle) xHandle.disabled = true;
      if (onlyFansHandle) onlyFansHandle.disabled = true;
      if (mobileNumber) mobileNumber.disabled = true;
      if (message) message.disabled = true;

      const userInfo: UserInfo = {
        firstName: firstName.value,
        lastName: lastName.value,
        tiktokHandle: tiktokHandle?.value || undefined,
        instagramHandle: instagramHandle?.value || undefined,
        onlyFansHandle: onlyFansHandle?.value || undefined,
        xHandle: xHandle?.value || undefined,
        mobileNumber: mobileNumber?.value || undefined,
        message: message?.value || undefined,
      };

      return FetchData.updateUserProfile(userInfo)
          .then(():boolean => {
            form.classList.add('w-form-done');
            const loginRedirect = localStorage.getItem('redirect-url');
            const targetPage = loginRedirect
                ? decodeURIComponent(loginRedirect)
                : getCurrentDomainFolder(true);
            localStorage.removeItem('redirect-url');

            setTimeout(() => {
              window.location.replace(targetPage);
            }, 3000);
            return true;
          })
          .catch((error: Error):boolean => {
            return false;
          });
    });
  }
}
